import { ICardContractSended } from "./types"

import imgEmty from '@img/empty.svg'
import { IconClearClose } from "@img/icons"

import { Empty, Flex, Modal, Loader, Button, Table, Container } from "@ui/index"


/** Окно по выбору что отправлять в телегу */
export const CardContractSended = ({isOpen, isLoading, sendedList, handlerBtnSave, handlerButtonCancel, handlerSelectedDocuments}: ICardContractSended) => {
    return <>
        <Modal isOpen={isOpen} isEsc onCancel={handlerButtonCancel} overflowY="hidden" maxWidth="360px">
            <Flex className='modal_container'>
                <Flex flexDirection="row" alignItems="center" justifyContent="space-between" className='modal_container-header'>
                    <h4>Отправка документов</h4>

                    <Button variant='icon' size='md' onClick={handlerButtonCancel}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Container padding="4px" className='modal_container-body'>
                    <Flex className='modal_container-content'>
                        <Loader isOpen={isLoading} backdrop color='#f34e2e' title='Загрузка документов' />

                        <Table.Content isScrollVertical={false} minHeight='200px'>
                            {!sendedList.value
                                ? <Empty image={imgEmty} title="Документы отсутствуют" />
                                : sendedList.value.map((item, index) => (
                                    <Table.RowCheckBox key={index + 1} header={index + 1} headerWidth="40px"
                                        isSelected={item.isSelect}
                                        onClick={() => handlerSelectedDocuments(item.id)}>

                                        <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                            <p>{item.name}</p>
                                            <p style={{ opacity: '.7' }}>{item.telegram}</p>
                                        </div>
                                    </Table.RowCheckBox>

                                    // <Table.Row key={index} indexContent={`${item.isSelect ? '✔' : '✘'}`} indexContentWidth='30px' paddingInset='2px 8px' backgroundColor={`${item.isSelect ? '#32d732' : '#f34e2e'}`} onClick={() => handlerSelectedDocuments(item.id)}>
                                    //     <p>{item.name}</p>
                                    //     <p style={{ opacity: '.7' }}>{item.telegram}</p>
                                    // </Table.Row>
                                ))
                            }
                        </Table.Content>
                    </Flex>

                    <Button width='100%' onClick={handlerBtnSave}>Отправить</Button>
                </Container>
            </Flex>

            {/* <ToolTip anchorSelect="#tooltipBtnSelect" content='Выбрать' place="left" /> */}
            {/* <ToolTip anchorSelect="#tooltipBtnClear" content='Очистить' place="left" /> */}
            {/* <ToolTip anchorSelect="#tooltipBtnPaymentRefund" content='Кликните для изменения' place="bottom" /> */}
        </Modal>
    </>
}